<div class="page-wrapper chiller-theme toggled" [ngStyle]="commonservice.showTour">
  <main class="page-content">
    <div class="bgColor">
      <div class="container">
        <!-- Header -->
        <div class="row" style="height: 4em;">
          <div class="col-md-6">
            <p class="appTitle">Colleges</p>
          </div>
          <div class="col-md-6">
            <p class="adminName">
              {{ adminName }}
             <img
  [src]="adminImage"
  alt="Admin"
  class="admin-avatar rounded-circle"
/>
            </p>
          </div>
        </div>

        <!-- Search + Add row -->
        <div class="row my-4 align-items-center" *ngIf="!showAdd && !showEdit">
          <div class="col-12">
            <div class="search-row">
              <div class="search-input">
                <span class="search-icon" aria-hidden="true">
                  <i class="fa fa-search"></i>
                </span>

                <input
                  #searchInput
                  type="text"
                  class="form-control"
                  placeholder="Search College or Course..."
                  [(ngModel)]="searchval"
                  (ngModelChange)="onSearchInput($event)"
                  aria-label="Search"
                />

                <button
                  *ngIf="searchval"
                  class="clear-x"
                  type="button"
                  (click)="clearSearch($event)"
                  aria-label="Clear search"
                >
                  &times;
                </button>
              </div>

              <div class="add-action">
                <button type="button" class="btn add-course-btn" (click)="openAdd()">
                  <span class="plus">+</span>
                  <span class="label">Add College</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Table view -->
        <div class="tableView" *ngIf="showData">
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr style="border-bottom: 1px solid #ced4da;">
                  <th>S.NO</th>
                  <th>Colleges</th>
                  <th>Address</th>
                  <th>District</th>
                  <th>State</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let college of searchData; let i = index;">
                  <tr #boxCollege (mouseover)="onMouseOver($event)">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <img
                        width="30px"
                        height="30px"
                        [src]="college.image"
                        class="rounded-circle"
                      />
                      {{ college.collage_name }}
                    </td>
                    <td>{{ college.address }}</td>
                    <td>{{ college.districtName }}</td>
                    <td>{{ college.stateName }}</td>
                    <td style="text-align: center;">
                      <i
                        class="fa fa-eye iconEdit"
                        aria-hidden="true"
                        (click)="viewCollege(college)"
                      ></i>
                      <i
                        class="fa fa-pencil iconEdit"
                        aria-hidden="true"
                        (click)="editCollege(college)"
                      ></i>
                      <i
                        class="fa fa-trash-o iconEdit"
                        aria-hidden="true"
                        (click)="deleteCollege(college)"
                      ></i>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <!-- No data -->
        <div class="noData" *ngIf="showNodata">
          <h2>Currently No Data Available!</h2>
        </div>
      </div>

      <!-- Backdrop & Add/Edit Modal (reactive form only, no ngModel inside) -->
      <div class="backdrop" [class.show]="display === 'block'"></div>

      <div class="modal-wrapper" [class.show]="display === 'block'" [ngClass]="{ 'edit-mode': showEdit }">
        <div class="modal-dialog-centered">
          <div class="modal-content card-modal">
            <div class="modal-header">
              <h5 class="modal-title" *ngIf="showAdd">Add College</h5>
              <h5 class="modal-title" *ngIf="showEdit">Edit College</h5>
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <form [formGroup]="addCollegeForm" (ngSubmit)="addCollege()" novalidate>
                <div class="image-upload-wrapper">
                  <img
                    width="100"
                    height="100"
                    *ngIf="imageUrl"
                    [src]="imageUrl"
                    class="rounded-circle preview-img"
                  />
                  <label class="camera-icon-label" aria-hidden="true">
                    <i class="fa fa-camera"></i>
                    <input
                      type="file"
                      (change)="handleFileInput($event.target.files)"
                      hidden
                      accept="image/*"
                    />
                  </label>
                </div>

                <div class="error-messages">
                  <div *ngFor="let error of error_messages.clgImg">
                    <div class="error-message"
                         *ngIf="addCollegeForm.get('clgImg')?.hasError(error.type) && (addCollegeForm.get('clgImg')?.dirty || addCollegeForm.get('clgImg')?.touched)">
                      {{ error.message }}
                    </div>
                  </div>
                </div>

                <label>College Name</label>
                <input type="text" class="form-control" formControlName="clgName" />

                <div class="error-messages">
                  <div *ngFor="let error of error_messages.clgName">
                    <div class="error-message"
                         *ngIf="addCollegeForm.get('clgName')?.hasError(error.type) && (addCollegeForm.get('clgName')?.dirty || addCollegeForm.get('clgName')?.touched)">
                      {{ error.message }}
                    </div>
                  </div>
                </div>

                <label>Address</label>
                <!-- <textarea class="form-control" formControlName="clgAddress" rows="2"></textarea> -->
                <textarea class="form-control about-textarea" formControlName="clgAddress" rows="6"></textarea>


                <div class="row">
                  <div class="col-md-6">
                    <label>Select District</label>
                    <select class="form-control custom-select custom-select-sm" formControlName="clgDistrict">
                      <option value="">Select</option>
                      <option *ngFor="let district of disrictData" [value]="district.id">{{ district.district }}</option>
                    </select>
                  </div>

                  <div class="col-md-6">
                    <label>Select State</label>
                    <select class="form-control custom-select custom-select-sm" formControlName="clgState">
                      <option value="">Select</option>
                      <option *ngFor="let state of stateData" [value]="state.id">{{ state.state }}</option>
                    </select>
                  </div>
                </div>

                <label>Hint</label>
                <!-- <textarea class="form-control" formControlName="hint" rows="2"></textarea> -->
                <textarea class="form-control about-textarea" formControlName="hint" rows="6"></textarea>
                 

                <label>About us</label>
                <textarea class="form-control about-textarea" formControlName="objectivesVal" rows="6"></textarea>

                <label *ngIf="showAdd">Preferences</label>
                <div class="row" *ngIf="showAdd">
                  <div class="col-md-6">
                    <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" id="preYes" name="preVal" formControlName="preVal" [value]="1" />
                      <label class="custom-control-label" for="preYes">Eligible</label>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="custom-control custom-radio">
                      <input type="radio" class="custom-control-input" id="preNo" name="preVal" formControlName="preVal" [value]="0" />
                      <label class="custom-control-label" for="preNo">Not Eligible</label>
                    </div>
                  </div>
                </div>

                <!-- Courses: only render when scopeData present -->
                <div *ngIf="showAdd">
                  <label>Courses</label>
                  <div *ngIf="!scopeData || scopeData.length === 0" style="padding:0.5rem 0;">
                    Loading courses...
                  </div>

                  <div class="row" *ngIf="scopeData && scopeData.length">
                    <div class="col-md-4" *ngFor="let scope of scopeData; let i = index">
                      <div class="checkboxDesign">
                        <input type="checkbox"
                               class="form-check-input"
                               [checked]="scope.check"
                               (change)="onScopeToggle(scope)"
                               [id]="'scope_' + scope.id" />
                        <label [for]="'scope_' + scope.id">{{ scope.degree }} - {{ scope.courses }}</label>
                      </div>
                    </div>
                  </div>
                </div>

                <label class="uploadImage">Upload College Images
                  <i class="fa fa-camera iconCamera" aria-hidden="true"></i>
                  <input type="file" (change)="handleFileInputs($event)" multiple accept="image/*">
                </label>

                <div class="modal-actions" style="margin-top: 1rem;">
                  <button type="submit" class="commonBtn" *ngIf="showAdd">Add College</button>
                  <button type="button" class="commonBtn" *ngIf="showEdit" (click)="updateCollege()">Update</button>
                  <button type="button" class="btn btn-secondary" (click)="onCloseHandled()" style="margin-left: 0.5rem;">Cancel</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- Delete Modal -->
      <div class="backdrop" [class.show]="displayDelete === 'block'"></div>
      <div class="modal-wrapper small" [class.show]="displayDelete === 'block'">
        <div class="modal-dialog-centered">
          <div class="modal-content card-modal">
            <div class="modal-header">
              <button type="button" class="close" aria-label="Close" (click)="onCloseHandled()"><span aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body text-center">
              <p>Do you want to delete College ?</p>
              <button type="button" class="btn btn-success" (click)="delete()">Yes</button>
              <button type="button" class="btn btn-danger" (click)="onCloseHandled()" style="margin-left: 0.3em;">No</button>
              <p class="error" *ngIf="showErr" style="margin-top: 1rem;">{{ deleteErr }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </main>
</div>
